import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import styles from "../../../../../css/index.css";
import FooterLink from "../../FooterLink/index.js";
const SectionItem = props => /*#__PURE__*/React.createElement("div", {
  role: "listitem"
}, /*#__PURE__*/React.createElement(FooterLink, _extends({
  className: styles.sectionItem
}, props)));
export default SectionItem;